/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuctionDto } from '../models/auction-dto';
import { AuctionOptionDto } from '../models/auction-option-dto';
import { AuctionStatsDto } from '../models/auction-stats-dto';
import { createAuction } from '../fn/auction/create-auction';
import { CreateAuction$Params } from '../fn/auction/create-auction';
import { deleteAuction } from '../fn/auction/delete-auction';
import { DeleteAuction$Params } from '../fn/auction/delete-auction';
import { FindAuctionsResponseDto } from '../models/find-auctions-response-dto';
import { getAuction } from '../fn/auction/get-auction';
import { GetAuction$Params } from '../fn/auction/get-auction';
import { getAuctionOptions } from '../fn/auction/get-auction-options';
import { GetAuctionOptions$Params } from '../fn/auction/get-auction-options';
import { getAuctionPrebidIntake } from '../fn/auction/get-auction-prebid-intake';
import { GetAuctionPrebidIntake$Params } from '../fn/auction/get-auction-prebid-intake';
import { getAuctions } from '../fn/auction/get-auctions';
import { GetAuctions$Params } from '../fn/auction/get-auctions';
import { getAuctionStats } from '../fn/auction/get-auction-stats';
import { GetAuctionStats$Params } from '../fn/auction/get-auction-stats';
import { patchAuction } from '../fn/auction/patch-auction';
import { PatchAuction$Params } from '../fn/auction/patch-auction';
import { PrebidIntakeDto } from '../models/prebid-intake-dto';
import { sendConsignmentResultMail } from '../fn/auction/send-consignment-result-mail';
import { SendConsignmentResultMail$Params } from '../fn/auction/send-consignment-result-mail';
import { sendSummaryMail } from '../fn/auction/send-summary-mail';
import { SendSummaryMail$Params } from '../fn/auction/send-summary-mail';
import { sendUserPrebidsAcceptedMail } from '../fn/auction/send-user-prebids-accepted-mail';
import { SendUserPrebidsAcceptedMail$Params } from '../fn/auction/send-user-prebids-accepted-mail';
import { sendUserPrebidsOutBidMail } from '../fn/auction/send-user-prebids-out-bid-mail';
import { SendUserPrebidsOutBidMail$Params } from '../fn/auction/send-user-prebids-out-bid-mail';

@Injectable({ providedIn: 'root' })
export class GeneratedAuctionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAuctions()` */
  static readonly GetAuctionsPath = '/api/auctions';

  /**
   * Gets all auctions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctions$Response(params?: GetAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<FindAuctionsResponseDto>> {
    return getAuctions(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all auctions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctions(params?: GetAuctions$Params, context?: HttpContext): Observable<FindAuctionsResponseDto> {
    return this.getAuctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindAuctionsResponseDto>): FindAuctionsResponseDto => r.body)
    );
  }

  /** Path part for operation `createAuction()` */
  static readonly CreateAuctionPath = '/api/auctions';

  /**
   * Creates an auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuction()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAuction$Response(params: CreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
    return createAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuction$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAuction(params: CreateAuction$Params, context?: HttpContext): Observable<AuctionDto> {
    return this.createAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionDto>): AuctionDto => r.body)
    );
  }

  /** Path part for operation `getAuction()` */
  static readonly GetAuctionPath = '/api/auctions/{id}';

  /**
   * Get an auction by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuction$Response(params: GetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
    return getAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an auction by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuction(params: GetAuction$Params, context?: HttpContext): Observable<AuctionDto> {
    return this.getAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionDto>): AuctionDto => r.body)
    );
  }

  /** Path part for operation `deleteAuction()` */
  static readonly DeleteAuctionPath = '/api/auctions/{id}';

  /**
   * Deletes an auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuction$Response(params: DeleteAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuction(params: DeleteAuction$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchAuction()` */
  static readonly PatchAuctionPath = '/api/auctions/{id}';

  /**
   * Patches an auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAuction()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuction$Response(params: PatchAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
    return patchAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches an auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchAuction$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuction(params: PatchAuction$Params, context?: HttpContext): Observable<AuctionDto> {
    return this.patchAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionDto>): AuctionDto => r.body)
    );
  }

  /** Path part for operation `getAuctionStats()` */
  static readonly GetAuctionStatsPath = '/api/auctions/{id}/stats';

  /**
   * Get an auction by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionStats$Response(params: GetAuctionStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionStatsDto>> {
    return getAuctionStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an auction by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionStats(params: GetAuctionStats$Params, context?: HttpContext): Observable<AuctionStatsDto> {
    return this.getAuctionStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionStatsDto>): AuctionStatsDto => r.body)
    );
  }

  /** Path part for operation `getAuctionPrebidIntake()` */
  static readonly GetAuctionPrebidIntakePath = '/api/auctions/{id}/prebid-intake';

  /**
   * Gets when the accepted prebids of an auction came in, per hour and source.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionPrebidIntake()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionPrebidIntake$Response(params: GetAuctionPrebidIntake$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidIntakeDto>> {
    return getAuctionPrebidIntake(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets when the accepted prebids of an auction came in, per hour and source.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionPrebidIntake$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionPrebidIntake(params: GetAuctionPrebidIntake$Params, context?: HttpContext): Observable<PrebidIntakeDto> {
    return this.getAuctionPrebidIntake$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidIntakeDto>): PrebidIntakeDto => r.body)
    );
  }

  /** Path part for operation `getAuctionOptions()` */
  static readonly GetAuctionOptionsPath = '/api/auctions/options';

  /**
   * Gets all auctions as simple id / title tuples.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionOptions$Response(params?: GetAuctionOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionOptionDto>>> {
    return getAuctionOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all auctions as simple id / title tuples.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionOptions(params?: GetAuctionOptions$Params, context?: HttpContext): Observable<Array<AuctionOptionDto>> {
    return this.getAuctionOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionOptionDto>>): Array<AuctionOptionDto> => r.body)
    );
  }

  /** Path part for operation `sendSummaryMail()` */
  static readonly SendSummaryMailPath = '/api/auctions/{auctionId}/send-summary-mail';

  /**
   * Sends summary mails for customers / bidders.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSummaryMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendSummaryMail$Response(params: SendSummaryMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendSummaryMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends summary mails for customers / bidders.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendSummaryMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendSummaryMail(params: SendSummaryMail$Params, context?: HttpContext): Observable<void> {
    return this.sendSummaryMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendConsignmentResultMail()` */
  static readonly SendConsignmentResultMailPath = '/api/auctions/{auctionId}/send-consignment-result-mail';

  /**
   * Sends consignment result mails for consigners (#6642).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendConsignmentResultMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendConsignmentResultMail$Response(params: SendConsignmentResultMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendConsignmentResultMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends consignment result mails for consigners (#6642).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendConsignmentResultMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendConsignmentResultMail(params: SendConsignmentResultMail$Params, context?: HttpContext): Observable<void> {
    return this.sendConsignmentResultMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendUserPrebidsAcceptedMail()` */
  static readonly SendUserPrebidsAcceptedMailPath = '/api/auctions/{auctionId}/send-user-prebids-accepted';

  /**
   * Sends mails for customers / bidders about accepted prebids.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendUserPrebidsAcceptedMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendUserPrebidsAcceptedMail$Response(params: SendUserPrebidsAcceptedMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendUserPrebidsAcceptedMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends mails for customers / bidders about accepted prebids.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendUserPrebidsAcceptedMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendUserPrebidsAcceptedMail(params: SendUserPrebidsAcceptedMail$Params, context?: HttpContext): Observable<void> {
    return this.sendUserPrebidsAcceptedMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendUserPrebidsOutBidMail()` */
  static readonly SendUserPrebidsOutBidMailPath = '/api/auctions/{auctionId}/send-user-prebids-outbid';

  /**
   * Sends mails for customers / bidders about outbid prebids.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendUserPrebidsOutBidMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendUserPrebidsOutBidMail$Response(params: SendUserPrebidsOutBidMail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendUserPrebidsOutBidMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Sends mails for customers / bidders about outbid prebids.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendUserPrebidsOutBidMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendUserPrebidsOutBidMail(params: SendUserPrebidsOutBidMail$Params, context?: HttpContext): Observable<void> {
    return this.sendUserPrebidsOutBidMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
